// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2HJJy","head":"Table_head__27OZq","col":"Table_col__1u2dJ"};